import { RouteEntry } from "../../shared/routes";
import { Home } from "./Home";

export const homeRoutes: Array<RouteEntry> = [
    { path: '/', exact: true, component: Home, authorize: true },
    { path: '/monitoringreporting', exact: true, component: Home, authorize: true }, // Should be unused, but kept for backwards compability.
];
